import { useTranslation } from "react-i18next";
import ContentsBox from './ContentsBox';

import img1 from 'assets/images/solutions/optimizers/so/so1.jpg'
import img2 from 'assets/images/solutions/optimizers/so/so2.jpg'
import img3 from 'assets/images/solutions/optimizers/so/so3.jpg'
import ci from 'assets/images/solutions/optimizers/so/ci.png'

export default function ProductSo(){
  const {t} = useTranslation();
  const prefix = 'optimizers.company.so.body';

  const contents = [
    {
      title:t(`${prefix}.title-${1}`),
      comment:t(`${prefix}.comment-${1}`),
      img:img1,
    },
    {
      title:t(`${prefix}.title-${2}`),
      comment:t(`${prefix}.comment-${2}`),
      img:img2,
      reverse:true,
    },
    {
      title:t(`${prefix}.title-${3}`),
      comment:t(`${prefix}.comment-${3}`),
      img:img3,
      wide:true
    }
  ];
  return (
    <div className="flex justify-center">
      <div className="flex flex-col lg:w-[1200px] my-10">
        {/* Part 1 */}
        <div className="flex flex-col mt-4 mb-4 lg:mb-24 px-mobile lg:px-0">
          <img src={ci} width={'108px'} alt='ci'/>
          <p className="my-4 text-2xl font-thin text-gray-600 lg:text-3xl lg:font-thin">{t(`${prefix}.system-name`)}</p>
          <p className="text-sm text-gray-600 lg:text-base" dangerouslySetInnerHTML={{__html:t(`${prefix}.system-desc`)}}></p>
        </div>
        {/* Part 2 */}
        {contents.map((c, i)=>{
          return (
            <ContentsBox key={i} index={i} {...contents[i]}/>
          );
        })}
      </div>
    </div>
  );
}